import { render, staticRenderFns } from "./AppraisalView.vue?vue&type=template&id=0c5b07a2&scoped=true"
import script from "./AppraisalView.vue?vue&type=script&lang=js"
export * from "./AppraisalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b07a2",
  null
  
)

export default component.exports